import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinecabbookingpune() {



  const cardData =
  {
    keyword: ' Online Cab Booking Pune',
    heading: 'Sai Trupti Cabs: Online Cab Booking Pune',
    headingDescription: 'Sai Trupti Cabs offers fast and reliable online cab booking in Pune, making your local rides, airport transfers, and outstation journeys smooth, convenient, and stress-free. Our fleet includes well-maintained AC sedans, SUVs, Innova Crysta, and premium vehicles, all equipped with clean interiors and ample luggage space for a comfortable travel experience. Every booking is handled by a professional, background-verified driver who ensures punctual pickup anywhere in Pune, safe driving, and courteous service throughout your ride. We provide flexible options like instant cab booking, one way taxi, round trip travel, airport pickup and drop, and outstation cab services at transparent and affordable pricing with no hidden charges. With 24x7 online booking, quick confirmation, and dedicated customer support, Sai Trupti Cabs makes your cab booking in Pune easy, efficient, and completely hassle-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the pride of Pune — a majestic 18th-century fort built by the Peshwas that stands as a living symbol of Maratha valor and grandeur. Its mighty stone walls, elegant arches, and ornate gates recall the era when the fort served as the heart of the Maratha Empire. The iconic Delhi Darwaza and intricate fountains inside whisper tales of royal assemblies and fierce battles. Though partially destroyed by fire, its remains still exude historic strength and charm. The evening light-and-sound show brings these stories alive under the night sky, making Shaniwar Wada a must-visit for anyone exploring Pune’s glorious past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is both an architectural marvel and a monument of national pride, built in 1892 by Sultan Aga Khan III. During India’s freedom struggle, it served as a place of internment for Mahatma Gandhi, Kasturba Gandhi, and other leaders of the Quit India Movement. The palace’s Italian arches, sprawling gardens, and memorial halls radiate peace and reflection. Inside, a museum displays rare photographs, letters, and personal belongings of Gandhi. Every step through its serene corridors connects visitors to India’s journey of sacrifice and resilience. The palace is not just a landmark — it’s a shrine of history and hope."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, perched high in the Sahyadri Ranges about 30 km from Pune, is a place where nature, adventure, and history meet. It gained fame after the heroic Battle of Sinhagad, where Tanaji Malusare fought valiantly under Chhatrapati Shivaji Maharaj’s command. The steep trek to the top rewards visitors with breathtaking valley views and cool breezes. Local stalls selling steaming pithla-bhakri and lemon juice add a rustic charm to the experience. At sunrise, clouds drift past the ramparts, bathing the fort in gold. Sinhagad isn’t just a fort — it’s the heartbeat of Maratha bravery."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill offers Pune a spiritual retreat high above the city, combining devotion and panoramic beauty. The temple complex, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas in the 18th century. Climbing the 108 steps leading up the hill feels meditative, rewarded by sweeping views of Pune’s skyline. Early mornings fill the air with temple bells and cool breezes, while sunsets here are spectacular. The small Peshwa Museum nearby preserves relics of royal heritage. For those seeking calm, Parvati Hill is Pune’s natural and divine vantage point."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, known for its magnificent gold-adorned idol of Lord Ganesha. Founded over a century ago, the temple draws millions of devotees every year. During Ganesh Chaturthi, it becomes the epicenter of music, lights, and devotion, uniting the entire city in celebration. The atmosphere inside radiates calm and faith, with priests performing rituals that echo through the marble halls. Beyond religion, the temple supports numerous charitable activities, embodying the spirit of compassion. Visiting Dagdusheth Ganpati fills hearts with positivity and hope."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is not only a historic monument but also a monument of peace and purpose. Built in 1892, it became an important site in India’s struggle for freedom. The palace served as a detention site for Mahatma Gandhi, whose ashes are preserved here along with those of Kasturba Gandhi. The lush lawns and tranquil environment make it a serene retreat within the city. Its architecture combines European grace with Indian simplicity. Visitors come here to honor India’s freedom heroes and experience the quiet dignity of this national treasure."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove of India’s cultural legacy, created from the personal collection of Dr. Dinkar Kelkar. The museum houses over 20,000 artifacts — from antique musical instruments and ornaments to ancient sculptures and traditional household tools. The highlight is the recreated 17th-century Wada (Maratha Mansion) that immerses visitors in the lifestyle of old Pune. Each exhibit tells a story of creativity and craftsmanship. It’s a must-visit destination for art lovers and anyone curious about India’s timeless heritage."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, located just 20 km from Pune, is the city’s favorite weekend escape. Set against green hills and shimmering waters, the dam offers a peaceful spot for picnics, cycling, and evening strolls. During monsoon, the area comes alive with waterfalls and lush greenery, creating postcard-perfect scenery. Local vendors serve spicy bhajis and steaming tea along the banks, adding to the cozy atmosphere. As the sun sets, the reflection of golden light over the water creates an unforgettable sight. Khadakwasla Dam embodies the natural charm of Pune’s outskirts."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "In Koregaon Park lies the Osho International Meditation Resort — a lush sanctuary of calm and consciousness. Spread across landscaped gardens, it attracts seekers from all over the world. The resort offers meditation sessions, wellness therapies, and holistic programs in a setting that blends Zen architecture with tropical greenery. Silence, serenity, and self-discovery form the rhythm of life here. Visitors come to rejuvenate body and mind amid artistic spaces and tranquil energy. Osho Resort captures Pune’s cosmopolitan side — modern, mindful, and deeply spiritual."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, also known as Pu La Deshpande Udyan, is a harmonious fusion of Japanese landscaping and Indian flora. Spread over 10 acres, it features flowing streams, stone bridges, manicured lawns, and flower beds arranged in serene symmetry. Inspired by Japan’s Korakuen Garden, it symbolizes friendship between Pune and Okayama City. Families come here to walk, meditate, or simply unwind amidst scenic beauty. The garden’s peaceful design and cultural symbolism make it one of Pune’s most beautiful green retreats."
  }
],



  "services": [
    {
      "name": "Online Cab Booking Pune",
      "description": "Book your cab online in Pune instantly with our seamless and user-friendly platform. Choose from AC, Non-AC, Sedan, Ertiga, or Innova options for local or outstation travel. Our Online Cab Booking Pune service ensures real-time availability, instant confirmation, secure payment, and 24/7 customer support. Whether it’s a short city trip, airport transfer, corporate ride, or long-distance journey, enjoy transparent fares, clean vehicles, and professional drivers for a safe and comfortable experience."
    },
    {
      "name": "Pune Cab Online",
      "description": "Pune Cab Online offers convenient, quick, and affordable online cab booking services for all your travel needs. Book instantly through our website for city rides, intercity travel, or airport drops. Choose from a fleet of well-maintained vehicles including AC/Non-AC options and premium models. Our trained drivers ensure safety, punctuality, and comfort for every trip, making online cab booking in Pune easy and efficient."
    },
    {
      "name": "Taxi Booking Online Pune",
      "description": "Get hassle-free Taxi Booking Online in Pune with instant confirmation and flexible travel options. Whether you need a ride for local sightseeing, office commute, or an outstation destination, our platform allows you to compare prices and select from a variety of vehicles. With GPS-enabled cars, experienced drivers, and affordable fares, we ensure you get the best taxi service online in Pune every time you travel."
    },
    {
      "name": "AC Cab Booking Pune",
      "description": "Enjoy a cool and comfortable journey with AC Cab Booking Pune. Book online from a range of air-conditioned vehicles including Sedans, SUVs, and Innovas for local, outstation, or airport rides. Our service guarantees on-time pickup, professional drivers, and clean interiors, ensuring a pleasant travel experience in every weather condition across Pune and Maharashtra."
    },
    {
      "name": "Non AC Cab Online Pune",
      "description": "Book a Non-AC Cab Online in Pune for budget-friendly travel across the city or to nearby destinations. Ideal for short trips and regular commutes, these cabs are clean, comfortable, and operated by professional drivers. Enjoy transparent pricing, easy online booking, and timely pickups without compromising on safety or convenience."
    },
    {
      "name": "Innova Cab Online Pune",
      "description": "Book Innova Cabs Online in Pune for spacious, reliable, and comfortable travel. Perfect for families, groups, and corporate travelers, our Innovas come equipped with AC options, ample luggage space, and professional chauffeurs. Whether you’re traveling locally or planning an outstation trip, our online platform ensures easy booking, secure payments, and timely service."
    },
    {
      "name": "Ertiga Cab Online Pune",
      "description": "Rent Ertiga Cabs Online in Pune with instant booking, professional drivers, and affordable rates. The 7-seater Ertiga is ideal for family trips, corporate tours, or outstation journeys. Enjoy flexible pickup/drop options, AC comfort, clean interiors, and transparent pricing through our reliable online booking system."
    },
    {
      "name": "Luxury Cab Online Pune",
      "description": "Experience luxury and comfort by booking your Luxury Cab Online in Pune. Choose from high-end vehicles like Innova Crysta, BMW, or Mercedes for corporate events, weddings, or airport transfers. Enjoy plush interiors, professional chauffeurs, and top-tier service with instant online confirmation and round-the-clock support."
    },
    {
      "name": "Affordable Online Cab Pune",
      "description": "Book an Affordable Online Cab in Pune for local and outstation travel at budget-friendly rates. Our platform offers a variety of cars including AC/Non-AC options, ensuring comfort and safety without compromising on price. With transparent fares, quick booking, and 24x7 availability, traveling in and around Pune has never been easier or cheaper."
    },
    {
      "name": "Pune One Way Online Cab",
      "description": "Hire a Pune One Way Online Cab for convenient intercity travel. Pay only for the distance you travel with no return fare. Ideal for routes like Pune to Mumbai, Nashik, or Kolhapur, our one-way cabs ensure comfortable, timely, and safe journeys. Choose from multiple car types, book online instantly, and enjoy hassle-free intercity travel."
    },
    {
      "name": "Pune Drop Cab Online",
      "description": "Book Pune Drop Cabs Online for reliable one-way trips to airports, railway stations, or nearby cities. Enjoy flexible scheduling, clean vehicles, professional drivers, and transparent pricing. Whether it’s a business trip or a family drop, our online system ensures seamless booking and on-time service every time."
    },
    {
      "name": "Corporate Cab Online Pune",
      "description": "Our Corporate Cab Online Pune service caters to businesses and professionals looking for reliable transportation. Book premium AC vehicles online for client pickups, daily office commutes, or intercity business travel. We provide monthly packages, transparent billing, and professional chauffeurs for a smooth corporate travel experience."
    },
    {
      "name": "Wedding Cab Online Pune",
      "description": "Book Wedding Cabs Online in Pune for a comfortable and stylish experience. From luxury cars for the bride and groom to reliable vehicles for guests, our service ensures timely pickups and elegant presentation. Choose from decorated cabs, AC options, and experienced drivers for smooth, safe, and memorable wedding transportation."
    },
    {
      "name": "Outstation Cab Online Pune",
      "description": "Book your Outstation Cab Online from Pune for weekend trips, vacations, or long-distance travel. Choose from a variety of AC/Non-AC vehicles including Innova and Ertiga for comfortable journeys. Our online system ensures instant booking, transparent fares, and professional drivers who make your outstation ride safe and enjoyable."
    },
    {
      "name": "Best Online Cab Pune",
      "description": "Get the Best Online Cab Service in Pune offering comfort, affordability, and convenience in every ride. Whether you’re booking for local travel, airport transfers, or outstation journeys, our platform guarantees instant confirmation, affordable rates, and top-rated drivers. Enjoy a superior cab booking experience with secure payments and 24/7 support."
    }
  ],
  "tableData": [
    ["Online Cab Booking Pune", "Pune Cab Online"],
    ["Taxi Booking Online Pune", "AC Cab Booking Pune"],
    ["Non AC Cab Online Pune", "Innova Cab Online Pune"],
    ["Ertiga Cab Online Pune", "Luxury Cab Online Pune"],
    ["Affordable Online Cab Pune", "Pune One Way Online Cab"],
    ["Pune Drop Cab Online", "Corporate Cab Online Pune"],
    ["Wedding Cab Online Pune", "Outstation Cab Online Pune"],
    ["Best Online Cab Pune", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Online Cab Booking in Pune",
    "WhyChoosedescription": "Sai Trupti Cabs  offers seamless online cab booking throughout Pune — ideal for city travel, airport transfers, and outstation rides."
  },
  {
    "WhyChooseheading": "Instant Booking & Confirmation",
    "WhyChoosedescription": "Book your cab online in just a few clicks via our website or WhatsApp — enter pickup/drop, select vehicle, and get instant confirmation."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Rates",
    "WhyChoosedescription": "Enjoy clear and affordable pricing for all online cab bookings in Pune, with no hidden charges or surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, or luxury cars to match your group size, luggage, and travel needs."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained and courteous drivers are familiar with Pune routes, ensuring smooth, safe, and timely journeys."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "Book pickups from any location in Pune — city, suburbs, or airports — with drops to any destination within or outside the city."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All online booked vehicles are sanitized, regularly serviced, and maintained to provide a comfortable and reliable travel experience."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, route planning, or any travel-related queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Payment & Cancellation",
    "WhyChoosedescription": "Multiple payment options and simple cancellation/modification policies make online cab booking convenient and worry-free."
  }
]
































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  provide online cab booking services in Pune?',
    answer: 'Yes, Sai Trupti Cabs  offers convenient and reliable online cab booking services in Pune for local travel, airport transfers, corporate trips, and outstation journeys.',
  },
  {
    question: 'How can I book a cab online in Pune with Sai Trupti Cabs?',
    answer: 'You can book your cab online through our website or mobile app by selecting your pick-up location, vehicle type, and preferred time, or by contacting our 24×7 customer support for assistance.',
  },
  {
    question: 'What types of cabs are available for online booking in Pune?',
    answer: 'We provide hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, Urbania, and Tempo Travellers to suit different group sizes, travel needs, and budgets.',
  },
  {
    question: 'Are the drivers experienced for online cab trips booked in Pune?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced, ensuring a safe, comfortable, and timely journey for all online bookings in Pune.',
  },
  {
    question: 'Can I book an online cab in Pune for corporate, airport, or outstation travel?',
    answer: 'Certainly. Our online cab services in Pune cater to airport transfers, corporate travel, sightseeing, one-way trips, and round-trip outstation journeys.',
  },
  {
    question: 'Is the online cab booking service in Pune available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 online cab booking services in Pune, allowing you to schedule rides at any time according to your convenience.',
  },
  {
    question: 'What are the online cab booking fares in Pune?',
    answer: 'Online cab fares in Pune start from approximately ₹200-₹400 for local trips, while fares for longer routes depend on vehicle type, distance, and travel time.',
  },
  {
    question: 'What payment options are accepted for online cab bookings in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for a seamless and secure online booking experience.',
  },
  {
    question: 'What safety and hygiene protocols are followed for online cab bookings in Pune?',
    answer: 'All vehicles are sanitized before every trip, and our drivers adhere to strict safety and hygiene measures to ensure a secure and comfortable journey.',
  },
  {
    question: 'Is customer support available during online cab trips in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you before, during, and after your online cab ride in Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Kulkarni',
    feedback: 'Booking a cab online in Pune with Sai Trupti Cabs was very easy. The ride was comfortable, and the driver arrived on time.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meera Patil',
    feedback: 'Sai Trupti Cabs provides excellent online cab booking service in Pune. The app is user-friendly, and the ride was smooth.',
    rating: 5,
  },
];















































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Online Cab Booking Pune",
  "image": "https://saitrupticabs.com/assets/images/online-cab-booking-pune.jpg",
  "description": "Sai Trupti Cabs provides online cab booking in Pune for instant taxi reservation. Book AC sedan, SUV, Innova Crysta for local, airport and outstation travel with quick confirmation, professional drivers and 24x7 service.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "14280"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/online-cab-booking-pune"
  }
};






  return (
    <div>
 
<Helmet>
  <title>Online Cab Booking Pune | Instant Taxi ₹499 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Online cab booking in Pune starting at ₹499. Book instant taxi for local, airport and outstation travel with Sai Trupti Cabs. Fast confirmation, AC cars, and 24x7 service." 
  />

  <meta 
    name="keywords" 
    content="online cab booking pune, book taxi online pune, pune cab booking online, instant cab booking pune, online taxi pune, airport cab booking pune online, outstation cab booking pune online, cheap cab booking pune, innova cab booking pune online, sedan taxi booking pune, 24 hour cab booking pune" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newimages/3.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onlinecabbookingpune;